import * as Yup from 'yup';

export const machineryDieselConsumptionReportFormModel = {
  formId: 'machineryDieselConsumptionReportConfig',
  formField: {
    startTime: {
      name: 'month_year',
      label: 'Select Month & Year',
      type: 'date',
      errorMsg: 'Month and year is required!'
    }
  }
};

const {
  formField: {
    startTime
  }
} = machineryDieselConsumptionReportFormModel;

export const machineryDieselConsumptionReportInitialValues = {
  [startTime.name]: ''
};

export const machineryDieselConsumptionReportValidationSchema = Yup.object().shape({
  [startTime.name]: Yup.date().nullable().required(startTime.errorMsg)
});

export const machineryDieselConsumptionReportFormConfig = {
  formModel: machineryDieselConsumptionReportFormModel,
  initialValues: machineryDieselConsumptionReportInitialValues,
  validation: machineryDieselConsumptionReportValidationSchema
};
